/* eslint-disable no-console */
import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { green, red } from '@material-ui/core/colors';
import API from '@aws-amplify/api';

import { sortData, getSorting } from '../../../utils/sortTable';
import NutzerTableHead from './EmiViewUserTableHead';
import NutzerdetailsTable from './EmiViewUserDetailsTable';

const useStyles = makeStyles((theme) => ({
  '@global': {
    '.MuiInputBase-root': {
      fontSize: '1rem',
    },
  },
  root: {
    width: '100%',
    display: 'flex',
  },
  paper: {
    width: '100%',
  },
  firstTable: {
    width: '100%',
    marginRight: theme.spacing(4),
  },
  table: {
    minWidth: 600,
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  tableFooter: {
    display: 'flex',
    justifyContent: 'flex-end',
    flexDirection: 'row',
    paddingLeft: 24,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 12,
    },
  },
  paginationActions: {
    [theme.breakpoints.down('sm')]: {
      '& .MuiIconButton-root': {
        padding: 0,
      },
      marginLeft: 8,
    },
  },
  paginationToolbar: {
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
    },
  },
  paginationInput: {
    [theme.breakpoints.down('sm')]: {
      marginRight: 8,
    },
  },
  cellWidth: {
    maxWidth: '28vh',
  },
  editingCell: {
    padding: 12,
  },
  editIcon: {
    position: 'absolute',
    top: -16,
    right: -38,
  },
  checkIcon: {
    margin: 4,
    cursor: 'pointer',
    '&:hover': {
      color: green[500],
    },
  },
  clearIcon: {
    margin: 4,
    cursor: 'pointer',
    '&:hover': {
      color: red[500],
    },
  },

  editable: {
    position: 'relative',
    display: 'inline-block',
  },

}));

export default function ViewUserTable() {
  const classes = useStyles();

  const [order, setOrder] = useState<SortingOrder>('asc');
  const [orderBy, setOrderBy] = useState('E-Mail');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [data, setData] = useState<EmiViewUser[]>([]);
  const [openDetails, setOpenDetails] = useState(false);
  const [selectedMail, setSelectedMail] = useState('');

  const handleRequestSort = (_event: any, property: string) => {
    const isDesc = orderBy === property && order === 'desc';
    setOrder(isDesc ? 'asc' : 'desc');
    setOrderBy(property);
  };

  const handleChangePage = (_event: any, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  async function fetch() {
    try {
      const res = await API.get('emilog', 'nutzer', {});
      setData(res);
    } catch (e) {
      console.error(e);
    }
  }

  useEffect(() => {
    fetch();
  }, []);

  function handleRowClick(email: string) {
    if (selectedMail === email) {
      setSelectedMail('');
      setOpenDetails(false);
    } else {
      setSelectedMail(email);
      setOpenDetails(true);
    }
  }

  return (
    <div className={classes.root}>
      <Paper className={openDetails ? classes.firstTable : classes.paper}>
        <div className={classes.tableWrapper}>
          <Toolbar variant="dense">
            <Typography variant="h5">Registrierte Nutzer</Typography>
          </Toolbar>
          <Table className={classes.table} aria-label="simple table">
            <NutzerTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
            />
            <TableBody>
              {(sortData(data, getSorting(order, orderBy)) as EmiViewUser[])
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map(({
                  Email, Anlagen,
                }, index: number) => {
                  const labelId = `nutzer-table-${index}`;

                  return (
                    <TableRow
                      tabIndex={-1}
                      key={Email}
                      onClick={() => handleRowClick(Email)}
                      selected={Email === selectedMail}
                      hover
                    >
                      <TableCell align="left" component="th" id={labelId} scope="row">{Email}</TableCell>
                      <TableCell align="right" component="th" id={labelId} scope="row">
                        {Anlagen.length}
                      </TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </div>
        <div className={classes.tableFooter}>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25, 50]}
            component="div"
            count={data ? data.length : 0}
            rowsPerPage={rowsPerPage}
            page={page}
            labelRowsPerPage="Nutzer pro Seite"
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            classes={{
              actions: classes.paginationActions,
              toolbar: classes.paginationToolbar,
              input: classes.paginationInput,
            }}
          />
        </div>
      </Paper>
      {openDetails && (
        <NutzerdetailsTable
          email={selectedMail}
        />
      )}
    </div>
  );
}
